import type { DataProvider } from '@refinedev/core';

/**
 * Compose multiple data provider enhancers
 * Usage: compose(a, b, c)(dataProvider) // applies c, then b, then a (right-to-left)
 */
export const compose =
  (...fns: Array<(provider: DataProvider) => DataProvider>) =>
  (provider: DataProvider) =>
    fns.reduceRight((acc, fn) => fn(acc), provider);
